import { Flex, Text } from '@chakra-ui/react';
import ListItem from 'common/components/list-item';
import { FaCreditCard, FaQuoteLeft, FaUser } from 'react-icons/fa6';


const SignupInfo = ({
  
}) => {
  return (
    <Flex className='flex-col gap-6 py-6 px-6 border border-gray-200 bg-white rounded-md'>
      <ListItem
        title='Today'
        description="Create an account and get a no obligation quote at any address."
        iconText={<span className='font-bold text-base'>1</span>}
        line
      />
      <ListItem
        title='Decide on a Rental'
        description="Decide on a unit and finalize your lease details."
        iconText={<span className='font-bold text-base'>2</span>}
        line
      />
      <ListItem
        title='Purchase Coverage'
        description='Eligible renters must purchase coverage within 7 days of signing a lease.'
        iconText={<span className='font-bold text-base'>3</span>}
        // line
      />
      {/* <ListItem
        title="Don't Forget"
        description='You must enroll within 7 days of your lease signing date. Don’t worry, we’ll remind you about that, too.'
        iconText={<span className='font-bold text-base'>4</span>}
      /> */}
    </Flex>
)}

export default SignupInfo